"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var menuSlideout_1 = __importDefault(require("./menuSlideout"));
var overlay_1 = __importDefault(require("./overlay"));
var Modal = /** @class */ (function () {
    function Modal() {
        this.config = {
            nodeLists: {
                modals: null,
                open: null,
                close: null
            },
            selectors: {
                modal: '[data-modal]',
                open: '[data-modal-open]',
                close: '[data-modal-close]'
            }
        };
    }
    Modal.prototype.init = function () {
        this.config.nodeLists.modals = document.querySelectorAll(this.config.selectors.modal);
        this.config.nodeLists.open = document.querySelectorAll(this.config.selectors.open);
        this.config.nodeLists.close = document.querySelectorAll(this.config.selectors.close);
        this.addEventListeners();
    };
    Modal.prototype.addEventListeners = function () {
        var _this = this;
        this.config.nodeLists.open.forEach(function (htmlElement) { return htmlElement.addEventListener('click', _this.handleClick.bind(_this, htmlElement)); });
        this.config.nodeLists.close.forEach(function (htmlElement) { return htmlElement.addEventListener('click', _this.close.bind(_this, htmlElement)); });
    };
    Modal.prototype.handleClick = function (htmlElement) {
        var key = htmlElement.dataset.key;
        if (key)
            this.open(key);
    };
    Modal.prototype.open = function (key) {
        var activeModal = this.getActiveModal(key);
        activeModal.classList.add('modal--active');
        menuSlideout_1.default.close();
        overlay_1.default.on();
    };
    Modal.prototype.close = function (htmlElement) {
        htmlElement.closest(this.config.selectors.modal).classList.remove('modal--active');
        var html = document.body.parentNode;
        overlay_1.default.off();
    };
    Modal.prototype.getActiveModal = function (key) {
        return Array.from(this.config.nodeLists.modals).find(function (htmlElement) { return htmlElement.dataset.key === key; });
    };
    return Modal;
}());
exports.default = new Modal();
